<!-- OrderDetailBody.vue -->
<template>
    <div>
        <div class="common-header-wrap">
            <mt-header title="兑换详情" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div
                class="order-body"
                v-if="order_info"
        >
            <div class="order_state">
                <i class="iconfont" v-if="order_info.point_orderstate == '40'">&#xe61b;</i>
                <i class="iconfont" v-else>&#xe61a;</i>
                <span>{{order_info.point_orderstatetext}}</span>
            </div>

            <div class="address">
                <div>
                    <span>{{ orderaddress_info.pointoa_truename }}</span>
                    <span class="mobile">{{ orderaddress_info.pointoa_mobphone }}</span>
                </div>
                <p style="-webkit-box-orient: vertical; -webkit-line-clamp: 2;">
                    {{ orderaddress_info.pointoa_areainfo }}{{ orderaddress_info.pointoa_address }}
                </p>
            </div>

            <div
                    class="containers"
                    v-for="item in prod_list"
                    v-bind:key="item.pointog_goodsid"
            >

                <img
                        class="photo"
                        v-bind:src="item.pointog_goodsimage"
                />
                <div class="right-wrapper">
                    <label class="title">{{ item.pointog_goodsname }}</label>
                    <div class="desc-wrapper">
                        <label class="price"
                        >{{ item.pointog_goodspoints }}积分</label
                        >
                        <label class="count">x{{ item.pointog_goodsnum }}</label>
                    </div>
                </div>
            </div>

            <div class="detail">
                <div class="number">
                    <label
                    >订单编号：{{ order_info.point_ordersn }}
                    </label>
                    <p>
                        下单时间：{{order_info.point_addtime}}
                    </p>
                </div>


            </div>

            <div
                    class="desc section-header section-footer"
            >


                <label class="amount"
                >实付款 : <span> {{ order_info.point_allpoint }}积分</span>
                </label>
            </div>

        </div>
    </div>
</template>

<script>

import { Toast } from 'mint-ui'
import { getOrderInfo } from '../../../api/memberPointsorder'
export default {
  name: 'MemberOrderDetail',
  data () {
    return {
      order_info: {},
        orderaddress_info:{},
        prod_list:{},
    }
  },

  created: function () {
    if (this.$route.query.point_orderid) {
      getOrderInfo(this.$route.query.point_orderid).then(res => {
        this.order_info = res.result.order_info
          this.orderaddress_info = res.result.orderaddress_info
          this.prod_list=res.result.prod_list
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  },

  methods: {

  }
}
</script>
<style lang="scss" scoped>
    .common-header-wrap .common-header{box-shadow: unset}
    .order-body {
        overflow: auto;
        height: 100%;
        position: absolute;
        width: 100%;
        .desc{
            .container {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                background-color: #fff;
            }
            .title {
                width:5rem;
                font-size:$subFontSize;
                color: #333;
                margin-left:0.6rem;
            }
            .subtitle {
                flex: 1;
                margin-left:1rem;
                margin-right:0.6rem;
                color: $primaryColor;
                font-size:$subFontSize;
                text-align: right;
            }
        }

    }
    .order_state {
        background:$primaryColor;
        height:3.5rem;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        i {
            color:#fff;
            font-size:1.2rem;
            padding: 0 0.5rem;
        }
        span {
            font-size:$h2;
            color: #fff;
        }
    }
    .containers {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: stretch;
        background-color: #fff;
        border-bottom: 1px solid #e8eaed;
    }
    .photo {
        width:4rem;
        height:4rem;
        margin:0.75rem 0.5rem 0.75rem 0.75rem;
        border: 1px solid #e8eaed;
        flex-basis:4rem;
        flex-shrink: 0;
    }
    .right-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        padding: 0 0.75rem 0 0;
        width: 100%;
        overflow: hidden;
    }
    .title {
        margin-top:0.75rem;
        color: #333;
        font-size:$subFontSize;

        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .property {
        font-size:$fontSize;
        color: #7c7f88;
        padding-top:0.5rem;
    }
    .count {
        margin-top:0.2rem;
        color: #7c7f88;
        font-size:$fontSize;
        margin-right:0.5rem;
    }
    .desc-wrapper {
        height:1rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding-top:1rem;
    }
    .price {
        color: $primaryColor;
        font-size:$h2;
        margin-left: 0;
    }
    .count {
        color: #7c7f88;
        font-size:$h2;
        margin-right:0.5rem;
    }
    .address {
        height:4.3rem;
        background-color: #fff;
        margin-bottom:0.5rem;
        div {
            padding:0.5rem 0.5rem 0;
        }
        img {
            height:0.8rem;
        }
        span {
            color: #333;
            font-size:$h2;
            &.mobile {
                padding-left:1rem;
            }
        }
        p {
            margin: 0.25rem 0.9rem 0.5rem 0.5rem;
            font-size:$subFontSize;
            color: #7c7f88;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
        }
    }

    .contact {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        height:2.3rem;
        background-color: #fff;
        margin-top:0.4rem;
        border-bottom: 1px solid #e8eaed;
        padding: 0 0.65rem;
        span {
            font-size:$fontSize;
            color: #333;
            padding-right:0.3rem;
        }
        img {
            width:0.6rem;
            height:0.65rem;
        }
    }

    .detail {
        display: flex;
        flex-direction: column;
        font-size:$subFontSize;
        color: #7c7f88;
        background-color: #fff;
        margin:0.4rem 0;
        box-sizing: border-box;
        .number {
            padding:0.7rem 0.8rem;
            border-bottom: 1px solid #e8eaed;
            p {
                padding-top:0.3rem;
                font-size:$subFontSize;
            }
            button {
                color: #7c7f88;
                height:1rem;
                background-color: #fff;
                border: 1px solid #7c7f88;
                width:2.7rem;
                height:1rem;
                border-radius:0.1rem;
                font-size:$subFontSize;
            }
        }
        .pay {
            border-bottom: 1px solid #e8eaed;
            padding:0.7rem 0.8rem;
        }
        .givetime {
            padding:0.7rem 0.8rem;
            font-size:$subFontSize;
        }
        input {
            background-color: #fff;
            border: 1px solid #7c7f88;
        }
    }
    .desc {
        background-color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        box-sizing: border-box;
        margin-bottom:4rem;
        .desc-item {
            flex: 1;
            margin-top:0.5rem;
        }
        .amount {
            display: flex;
            justify-content: flex-end;
            font-size:$subFontSize;
            color: #333;
            padding-right:0.75rem;
            height:2.2rem;
            line-height:2.2rem;
            span {
                font-size:$h2;
                color: $primaryColor;
            }
        }
    }
    .ship {
        margin-bottom: 0;
    }
</style>

<!-- 字体图标样式覆盖 -->
<style lang="scss">
    .mint-toast-icon {
        font-size:1.9rem;
    }
    button {
        padding: 0;
    }
</style>
